export default __webpack_public_path__ + "static/media/userRed.4012d68f.svg";